import React, { useContext } from 'react';
import CompanyContext from 'company/CompanyContext';

const CompanyTerms = ({ booking }) => {
  // eslint-disable-next-line no-unused-vars
  const { company } = useContext(CompanyContext);
  const plainText = booking && booking.termsAndConditions ? rtfToPlainText(booking.termsAndConditions) : '';

  function rtfToPlainText(rtf) {
    // Remove fonttbl, colortbl, and other header groups
    rtf = rtf.replace(/\\fonttbl.*?;/gs, '');
    rtf = rtf.replace(/\\colortbl.*?;/gs, '');
    rtf = rtf.replace(/\\.*?;/gs, '');
    // Remove remaining RTF control words and groups
    rtf = rtf.replace(/\\[a-z]+\d* ?/g, '');
    rtf = rtf.replace(/[{}]/g, '');
    rtf = rtf.replace(/;/g, '');
    // Replace paragraph tags with newlines
    rtf = rtf.replace(/\\par[d]?/g, '\n');
    // Remove extra newlines and spaces
    rtf = rtf.replace(/\n\s*\n/g, '\n').trim();

    return rtf;
  }

  return (
    <p dangerouslySetInnerHTML={{ __html: plainText }}></p>
  );
};

export default CompanyTerms;
